(function() {
    'use strict';
 
a3_pilot_reports.filter('searchTextFilterforCategories', searchTextFilterforCategories);

    /**
    * @memberof PilotReports
    * @ngdoc filter
    * @name searchTextFilterforCategories
    * @description 
    *   Filter questions by search text
    * @ngInject
    */
function searchTextFilterforCategories() {
      return function (input, obj) {
	
			var items = {
					searchText: (obj.searchText) ? obj.searchText.toLowerCase():"",
					out: []
			};
			if(!items.searchText || items.searchText == ''){
				items.out = input;
			}else{
				angular.forEach(input, function (value, key) {
						if (value.Label.toLowerCase().indexOf(this.searchText) >= 0 || value.Description.toLowerCase().indexOf(this.searchText) >= 0) {
								this.out.push(value);
						}
				}, items);
			}

			var categoryLabels = items.out.dynamicSort('CategoryOrderNo').map(function(r){
				return r.CategoryLabel;
			});

			return categoryLabels.unique();
	  };
	};
 })();   